export const GROUP_LESSONS_PLUSES_LIST = [{
  header: 'Разговорная практика',
  text: 'В&nbsp;деловом английском важно уметь общаться не&nbsp;только с&nbsp;одним преподавателем, но&nbsp;и&nbsp;успешно коммуницировать с&nbsp;людьми с&nbsp;разным произношением, акцентом и&nbsp;уровнем языка. Занятия в&nbsp;группе&nbsp;&mdash; лучшее решение для работы в&nbsp;международной команде'
}, {
  header: 'Небольшие группы (до 5-6 человек)',
  text: 'Каждому уделяляется достаточно времени, а&nbsp;также вы&nbsp;получаете обратную связь от&nbsp;преподавателя после каждого урока'
}, {
  header: 'Без воды',
  text: 'Вы&nbsp;обсуждаете только&nbsp;то, что нужно для собеседований и&nbsp;работы за&nbsp;границей'
}, {
  header: 'Интерактивные платформы',
  text: 'На занятиях мы используем Miro, Progressme, онлайн словари, аутентичные материалы: видео и&nbsp;статьи на&nbsp;актуальные вам темы'
}];